<template>
	<div style="background-color:#fffcf7;" class="container">
		<headMenu />
		<div class="w-100 overflow-hidden" :class="(windowWidth <= 1000) ? 'h-center' : ''">
			<div class="col-lg-9 col-md-9 col-sm-12 col-xs-12 float-left p-3">
				<support />
				<back title="در خواست ها" showBtn="false"
				 :leftBtn="!['1','4','5','6','7','8'].includes($localStorage.get('user').username.access_level)" 
				 leftBtnType="success" leftBtnText="ثبت درخواست"
					
					v-if="$localStorage.get('user').username.role == 3" @clickMe="$router.push('/reserved/user/create')"
					@clickMe2="filter = !filter" />
				<div class="w-100 overflow-hidden" style="" v-if="filter">
					<h2 class='bMikhak w-100 text-center'>
						دریافت گزارش
					</h2>
					<datepicker class="col-6 pr-0 float-right overflow-hidden" min="false" label="از تاریخ"
						@input="(e) => { val.from = e }" :value="val.from" />
					<datepicker class="col-6 pl-0 float-right overflow-hidden" min="false" label="تا تاریخ"
						@input="(e) => { val.to = e }" :value="val.to" />
				</div>
				<btn text="ذخیره" class="mt-3 w-100" textClass="w-100"
					:disable="(val.to == '' || val.from == '') ? '1' : '0'" @clickMe="xlsx()" v-if="filter" />
				<input 
					type="text" 
					class="p-4 w-100 border-15 form-control shadow mb-3 mt-3" 
					placeholder="جستجو کنید..."
					:style="'background-image:url(' + require('../../assets/img/Search.svg') + ')'"
					style="background-repeat: no-repeat; background-position: 15px center; background-size: 25px;"
					@input="loader(1, $event.target.value)" 
					v-if="$localStorage.get('user').username.role == 3" 
					v-model="input_search"
				/>

				<div class="w-100 row d-flex align-items-center mb-4" v-if="$localStorage.get('user').username.role==3">
					<div class="col-4"><inputcalender placeholder="تاریخ رزرو" label="تاریخ رزرو" leading="" @inputdate="(e)=>{filter_pro.date=e}" /></div>
					<div class="col-4"><inputcalender placeholder="تاریخ شروع کلاس" label="تاریخ شروع کلاس" leading="" @inputdate="(e)=>{filter_pro.dateclass=e}" /></div>
					<div class="col-4"><btn text="جستجو" class="mt-3 w-100" textClass="w-100" @clickMe="loader()" /></div>
				</div>
				<part1 :flds="flds.data" v-if="flds.ok == true" @setPage="setPage" />
				<empty v-else-if="flds.ok == false && $localStorage.get('user').username.role==1" text="درخواستی توسط شما ثبت نشده است" />
				<empty v-else-if="flds.ok == false && $localStorage.get('user').username.role==2" text="در خواستی توسط کاربر برای شما  ثبت نشده است" />
				<empty v-else-if="flds.ok == false && $localStorage.get('user').username.role==3" text="در خواستی توسط کاربر  ثبت نشده است" />
				<loading v-else-if="flds.ok == null" text="لطفا صبر کنید" />
			</div>
			<div class="col-lg-3 col-md-3 float-left" v-if="windowWidth > 1000">
				<part2 select="0" />
			</div>
		</div>
		<footerPage />

		<div id="status_3" class="d-none">
			<div class="position-relative h-50 d-flex  align-items-center justify-content-center flex-column bg-white box">
				<img
					height="35px;"
					:src="require('../../assets/img/Logo_Header.svg')"
					alt="ایزی تیک"
					title="ایزی تیک"
				/>
				<div class="mb-2 mt-4"><span> لطفا برای دسترسی به پنل خودتان </span></div>
				<div class=""><span>با شماره های پشتیبانی ایزی تیک 88625168-021 و 88618512-021 تماس بگیرید.</span></div>
				<div class="d-flex align-items-center justify-content-center bg-white whatsapp mt-3">
					<div class="d-flex align-items-center justify-content-center p-3 border-15" style="background-color: #093836;">
						<img
							:src="require('../../assets/img/whatsapp_white.svg')"
							width="16"
						/>
					</div>
				</div>
			</div>
		</div>




	</div>
</template>

<script>
// import XLSX from 'xlsx';

import part1 from "./part1.vue";
import part2 from "./part2.vue";
import btn from "../../UI/button/btn.vue";
import datepicker from "../../UI/input/datepicker.vue";
import inputcalender from "../../UI/calendar/inputcalender.vue";
import back from "../../UI/back/back.vue";
import empty from "../../UI/empty/empty.vue";
import loading from "../../UI/loading/loading.vue";
import headMenu from "../../menu/headMenu.vue";
import footerPage from "../public/home/home_part9.vue";
import selectInput from "../../UI/input/selectInput.vue";
import support from "../../UI/support/support.vue";
import { error, showImg } from "../../assets/library/messege.js";

export default {
	name: 'reserved_user_list',
	data() {
		return {
			error: error,
			showImg: showImg,
			imgurl: window.imgurl,
			baseurl: window.baseurl,
			flds: { ok: null, data: [] },
			filter: false,
			degrees: [],
			category: [],
			location: [],
			val: {
				from: '',
				to: '',
			},
			input_search: "",
			page: 1,
			status: (this.$route.query.status) ? this.$route.query.status : 0,
			filter_pro:{
				date: "",
				dateclass: "",
			}
		}
	},
	components: {
		btn,
		back,
		empty,
		loading,
		part1,
		part2,
		footerPage,
		headMenu,
		datepicker,
		selectInput,
		inputcalender,
		support
	},
	props: [],
	computed: {
	},
	mounted() {
		this.page = (this.$route.query.page != undefined) ? this.$route.query.page : 1 ;
		this.input_search = (this.$route.query.search != undefined) ? this.$route.query.search : "" ;
		this.$swal.close();
		if (this.$localStorage.get('user') == null) {
			this.$localStorage.set('urlPath', window.location.pathname);
			this.$router.push('/login');
		} else if(this.$localStorage.get('user').username.status==3 || this.$localStorage.get('user').username.status==5){
			this.$swal.fire({
				icon: '',
				title: "",
				html: $("#status_3").html(),
				confirmButtonText: "بستن",
			}).then(() => {
				this.$localStorage.remove('user');
				this.$router.push('/oneTimePassword');
			})
		} else {
			this.loader(this.page, this.input_search);
		}
	},
	methods: {
		xlsx(THIS = this) {
			// window.$.post(this.baseurl + 'xlsx/reserved', { token: this.$localStorage.get("user"), from: THIS.val.from, to: THIS.val.to }, function (D) {
			// 	if (D.status.code == "401") {
			// 		THIS.$localStorage.remove('user');
			// 		THIS.$router.push('/login');
			// 	} else if (D.status.code == "400") {
			// 		THIS.error(THIS, "اطلاعاتی یافت نشد");
			// 	}
			// 	else {
			// 		const data = XLSX.utils.json_to_sheet(D.data)
			// 		const wb = XLSX.utils.book_new()
			// 		XLSX.utils.book_append_sheet(wb, data, 'data')
			// 		XLSX.writeFile(wb, 'reserved.xlsx');
			// 		THIS.val.to = '';
			// 		THIS.val.from = '';
			// 	}
			// }, "json");
		},
		// *********************************************************************
		setPage(p){
			this.page = p;
			this.loader(this.page, this.input_search);
		},
		// *********************************************************************
		loader(p = 1, search = '', THIS = this) {
			let query = { 
				page: p.toString(),
				search: search,
				status: this.status,
			};
			this.$router.push({query: query});

			document.body.scrollTop = 0;
			let user;
			if (this.$localStorage.get("user").username.role != 3) {
				user = this.$localStorage.get("user").username.id;
			} else if (this.$route.params.id != undefined) {
				user = this.$route.params.id;
			} else {
				user = '';
			}
			window.$.post(this.baseurl + 'reserved/teachers?n=5&p=' + p, {
				token: this.$localStorage.get("user"),
				search: search,
				filter_pro: this.filter_pro,
				username: user,
				role: this.$localStorage.get("user").username.role,
				token: this.$localStorage.get("user"),
				status: this.status
			}, function (D) {
				if(D.status.code=="401"){
					THIS.$localStorage.remove('user');
					THIS.$router.push('/login');
				}else{
					THIS.flds = {ok: false, data: []};
					if (search == D.data.search) {
							THIS.flds = D;
						}
				}
			}, "json");
		}
		// *********************************************************************
	}
}
</script>
<style>

</style>
